// extracted by mini-css-extract-plugin
module.exports = {"loader":"Placeholder_loader__GEb4G","placeholder":"Placeholder_placeholder__Y8NQR","static":"Placeholder_static__lTY20"};